import React from 'react'
import { useEventLogging } from '@packages/jslib'
import Image from 'next/image'

import Button, { BaseButtonStyleClassName } from '@components/Button'
import { CommentaryVideo } from '@components/QuestionGroupBoxes'
import { getImageUrl } from '@lib/simpleFn'

const CommentaryVideoBannerOrigin = ({ video }: { video: CommentaryVideo }) => {
  const { trackButtonClick } = useEventLogging()
  const buttonClassName = `${BaseButtonStyleClassName} text-white bg-bosalpim !py-1.5 sm:!py-2.5`
  return (
    <div className={'shadow-md py-2 sm:py-4 px-7 sm:px-0'}>
      <div className={'flex mx-auto w-full sm:w-[620px] justify-between items-center'}>
        {video.thumbnail && (
          <div className={'w-[96px] h-[54px] sm:w-auto sm:h-auto'}>
            <Image
              src={getImageUrl(video.thumbnail, 'jpg')}
              width="128"
              height="72"
              alt={video.title ? video.title : '모의고사 해설영상'}
              unoptimized
            ></Image>
          </div>
        )}
        <div className={'flex flex-1 pl-2 sm:pl-4 flex-col justify-start'}>
          <div className={'text-base sm:text-2xl font-bold'}>모의고사 해설강의</div>
          <div className={'text-base sm:text-lg'}>
            {video.title ? video.title : 'CBT 모의고사 해설영상'}
          </div>
        </div>
        <div className={'w-[62px] h-[36px] sm:h-[44px]'}>
          <Button
            onClick={() => {
              trackButtonClick({
                name: 'Answer Solution',
              })
              window.open(video.url, '_blank')
            }}
            className={buttonClassName}
          >
            보기
          </Button>
        </div>
      </div>
    </div>
  )
}

export const CommentaryVideoBanner = React.memo(CommentaryVideoBannerOrigin)
